(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-showcase-scroller')) {
    customElements.define(
      'collection-showcase-scroller',
      class extends HTMLElement {
        connectedCallback() {
          const track = this.querySelector('[data-track]');
          const step = () => {
            const card = track.querySelector('.collection-showcase__card');
            return card ? card.getBoundingClientRect().width + 16 : 280;
          };
          this.querySelector('[data-prev]')?.addEventListener('click', () => {
            track.scrollBy({ left: -step(), behavior: 'smooth' });
          });
          this.querySelector('[data-next]')?.addEventListener('click', () => {
            track.scrollBy({ left: step(), behavior: 'smooth' });
          });

          const controls = this.querySelector('[data-controls]');
          const dotsWrap = this.querySelector('[data-dots]');
          const prev = this.querySelector('[data-prev]');
          const next = this.querySelector('[data-next]');
          const cards = Array.from(track.querySelectorAll('.collection-showcase__card'));

          dotsWrap.innerHTML = '';
          const dots = cards.map((card, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'collection-showcase__dot';
            dot.setAttribute('aria-label', 'Go to item ' + (index + 1));
            dot.addEventListener('click', () => {
              track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
            });
            dotsWrap.appendChild(dot);
            return dot;
          });

          const update = () => {
            const maxScroll = track.scrollWidth - track.clientWidth;
            controls.hidden = maxScroll <= 4;
            const atEnd = track.scrollLeft >= maxScroll - 4;
            let active = 0;
            cards.forEach((card, index) => {
              if (card.offsetLeft - track.offsetLeft <= track.scrollLeft + 8) active = index;
            });
            if (atEnd) active = cards.length - 1;
            dots.forEach((dot, index) => {
              dot.classList.toggle('is-active', index === active);
              dot.setAttribute('aria-current', index === active ? 'true' : 'false');
            });
            prev.disabled = track.scrollLeft <= 4;
            next.disabled = atEnd;
          };

          track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
          window.addEventListener('resize', update);
          update();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
